export default __webpack_public_path__ + "static/media/lunch.a3d9b942.png";